<template>
    <div class="col-lg-8 col-md-12 resa-row mx-auto">
        <p class="fw-bold fs-2 text-center mb-5">Choisissez votre date</p>
        <div class="calendar-container" style="width: 100%; max-width: 365px; margin: auto">
            <v-date-picker
                locale="fr"
                style="margin-bottom: 15px; border-radius: 11px"
                color="#000"
                header-color="#000"
                v-model="date"
                full-width
                first-day-of-week="1"
                :min="nowDate"
                :events="arrayEvents"
                event-color="green lighten-1"
                @input="menu = false"
                @change="changeDate"
            ></v-date-picker>
        </div>
        <div v-if="showDisponibilities" class="resa-col-12 basket-row mt-3 text-center">
            <p class="text-center sub-title-resa mt-5 mb-2">Disponibilités</p>
            <p v-if="this.isLoading" class="lds-span text-center mb-3" :style="ldsSpan">Chargement</p>
            <div class="lds-ring" v-if="this.isLoading">
                <div :style="ldsRing"></div>
                <div :style="ldsRing"></div>
                <div :style="ldsRing"></div>
                <div :style="ldsRing"></div>
            </div>
            <div
                v-if="this.establishment && this.spaces_list && this.spaces_list && this.isLoading == false"
                class="totalDiv mt-5"
            >
                <div class="row" v-if="(type === 'serie' || type === 'treatment') && !practiShow">
                    <div class="col-12 col-md-auto py-1" v-for="(timeslot, i) in this.time_slots" :key="i">
                        <div
                            v-if="timeslot[0]['error'] == null"
                            class="time-slots mx-auto px-3"
                            style="height: auto; cursor: pointer"
                            v-on:click="displayAllPracti(timeslot)"
                        >
                            <div class="g-row x-center">
                                <p>{{ displayDate(timeslot[0]['date']) }}</p>
                            </div>
                            <!--END  DEBUG  END-->
                        </div>
                    </div>
                </div>
                <div class="row" v-if="type === 'package'">
                    <div class="col-12 col-md-auto py-1" v-for="(timeslot, i) in this.time_slots" :key="i">
                        <div
                            v-if="timeslot[0]['error'] == null"
                            class="time-slots mx-auto px-3"
                            style="height: auto; cursor: pointer"
                            v-on:click="selectMultipleSlotPackage(timeslot, timeslot[0]['date'], currentDate)"
                        >
                            <div class="g-row x-center">
                                <p>{{ displayDate(timeslot[0]['date']) }}</p>
                            </div>
                        </div>
                        <div
                            v-if="timeslot['error'] != null"
                            class="time-slots"
                            style="height: auto; margin: 0px; margin-bottom: 25px; cursor: pointer; background-color: red"
                            v-on:click="
                                selectSlot($event, timeslot[0]['date'], currentDate, timeslot[0]['practi'], timeslot[0]['space'])
                            "
                        >
                            <div class="g-row x-around">
                                <p>{{ displayDate(timeslot[0]['date']) }}</p>
                                <p>{{ timeslot[0]['error'] }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="(type === 'prestation' || type === 'package') && !practiShow">
                    <div class="col-12 col-md-auto py-1" v-for="(timeslot, i) in this.time_slots" :key="i">
                        <!-- {{timeslot}} -->
                        <div
                            v-if="timeslot[0]['error'] == null"
                            class="time-slots mx-auto px-3"
                            style="height: auto; cursor: pointer"
                            v-on:click="displayAllPracti(timeslot)"
                        >
                            <div class="g-row x-center">
                                <p>{{ displayDate(timeslot[0]['date']) }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="this.sprs.length <= 0 && type != 'package' && type != 'treatment'">
                    Aucune activité sélectionnée.
                </div>
                <div
                    class="row"
                    v-else-if="!this.time_slots.length > 0 || this.isLoading"
                    style="display: flex; justify-content: center; align-items: center; height: 100%; width: 100%"
                >
                    <img src="/media/creneauNonDispo.gif" alt="creneauNonDispo" style="margin: 20px auto; width: 160px" />
                    <br />
                    <p>Aucun créneau disponible.</p>
                </div>
            </div>
        </div>

        <div style="margintop: 50px" v-if="this.selectDate && this.selectDate.length">
            <!-- <p style="font-weight: 100">{{ this.prestation['name'] }}</p>
    <p style="font-weight: 100">{{ displayDate(this.selectDate) }}</p> -->
            <p class="sub-title-resa texyt-center my-2">Activités réservées</p>
            <div class="row" style="margin-bottom: 2rem">
                <div
                    class="col-12 col-md-auto"
                    v-for="(prestation, i) in this.allPrestations"
                    :key="i"
                    style="font-weight: 100; margin-bottom: 5px; list-style: none"
                >
                    <span style="margin-bottom: 10px" v-for="(test, i) in prestation.prestation" :key="i">
                        <p>
                            {{ test.prestation.name }} - <b>{{ displayDate(test.date) }}</b>
                        </p>
                    </span>
                </div>
            </div>
        </div>

        <p v-if="practiShow" class="sub-title-resa">Choisissez votre praticien(ne) préferé(e) !</p>
        <div v-if="practiShow" class="description-resa">
            <div>Sélectionnez le/la praticien(ne) voulu(e) ou continuez.</div>
        </div>
        <div class="" v-if="practiShow" style="gap: 1rem; margin-top: 2rem">
            <div v-if="practiDispo.length > 0" class="totalDiv row">
                <div class="col-12 col-md-auto py-1" v-for="(practi, i) in practiDispo" :key="i" style="max-width: max-content">
                    <div
                        class="time-slots mx-auto px-3"
                        style="height: auto; cursor: pointer"
                        :style="[
                            practi.id == (currentPracti ? currentPracti.id : 0)
                                ? {
                                      'background-color': 'hsl(var(--p))',
                                      color: '#fff',
                                      'pointer-events': 'none',
                                      'border-color': 'hsl(var(--p))',
                                  }
                                : { 'background-color': 'hsla(var(--pf) / 0.2)' },
                        ]"
                        v-on:click="setPracti(practi)"
                    >
                        <div class="g-row x-around">
                            <p>{{ practi.first_name }}</p>
                            <img
                                v-if="practi.image != null"
                                style="
                                    border-style: solid;
                                    border-radius: 40px;
                                    height: 40px;
                                    width: 40px;
                                    margin-left: 5px;
                                    object-fit: cover;
                                "
                                :src="practi ? (practi.image ? practi.image : '/media/default.png') : null"
                            />
                            <div
                                v-else
                                class="no-img index-up"
                                style="
                                    border-style: solid;
                                    border-radius: 35px;
                                    height: 35px;
                                    width: 35px;
                                    max-width: 35px;
                                    max-height: 35px;
                                "
                            >
                                <span class="material-icons-outlined" style="font-size: 35px"> person </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="totalDiv row">
                <div class="col-12 col-md-auto py-1" v-if="practiDispo.length == 0">
                    <div
                        v-if="clicked"
                        :style="{
                            'background-color': 'hsl(var(--p))',
                            color: '#fff',
                            'pointer-events': 'none',
                            'border-color': 'hsl(var(--p))',
                        }"
                        class="time-slots mx-auto px-3"
                        style="height: auto; cursor: pointer"
                    >
                        Aucun staff
                    </div>
                    <div v-else class="time-slots mx-auto px-3" style="height: auto; cursor: pointer">Aucun staff</div>
                </div>
            </div>
            <p class="mt-4">Vous avez choisi : {{ currentPracti ? currentPracti.first_name : '' }}</p>
            <a
                v-if="showContiner"
                class="time-slots g-row"
                style="margin-top: 10px; width: max-content; cursor: pointer; margin: auto"
                v-on:click="
                    selectMultipleSlot(
                        selectedTimeSlot,
                        selectedTimeSlot[0]['date'],
                        currentDate,
                        currentPracti ? currentPracti.id : 0
                    )
                "
                >Continuer</a
            >
        </div>

        <input type="hidden" id="prestation" name="prestation" :value="JSON.stringify(this.prestation)" />
        <input type="hidden" id="select" name="select" :value="JSON.stringify(this.selectedSlot)" />
        <input type="hidden" id="practi" name="practi" :value="JSON.stringify(this.selectPracti)" />
        <input type="hidden" id="space" name="space" :value="JSON.stringify(this.selectSpace)" />
        <input type="hidden" id="type" name="type" :value="this.prestation.type" />
        <input type="hidden" id="nbUser" name="nbUser" :value="this.nb_user" />
        <input type="hidden" id="type" name="type" :value="this.type" />
        <input type="hidden" id="ok" name="ok" :value="1" />
        <input type="hidden" id="all" name="all" :value="JSON.stringify(this.allPrestations)" />
        <input type="hidden" name="test" id="test" value="tet" />

        <input v-if="this.type == 'serie'" type="hidden" id="serie_user_id" name="serie_user_id" :value="this.serie_user_id" />
        <input
            v-if="this.type === 'treatment'"
            type="hidden"
            id="treatment_user_id"
            name="treatment_user_id"
            :value="this.treatment_user_id"
        />
        <input
            v-if="this.type == 'package'"
            type="hidden"
            id="prestations"
            name="prestations"
            :value="JSON.stringify(this.prestations)"
        />
        <input
            v-if="this.type == 'package'"
            type="hidden"
            id="package_user_id"
            name="package_user_id"
            :value="this.package_user_id"
        />
    </div>
</template>
<style scoped>
/* Setting padding to 0 prevents hiding last week of the month on mobile devices */
div.v-date-picker-table > table > tbody > tr > td {
    padding: 0 !important;
}
</style>

<script>
import { addDays, dayToFrFormat } from '../utils/date'

export default {
    name: 'calenders',
    props: [
        'primaryColor',
        'user',
        'prestation',
        'staff',
        'type',
        'establishments',
        'serie_user_id',
        'treatment_user_id',
        'package_user_id',
        'voucher1',
        'voucher2',
        'voucher3',
        'sprs',
        'spsp',
    ],
    data: () => ({
        first_name: null,
        customers: [],
        last_name: null,
        availableSlots: [],
        unavailableSlots: [],
        arrayEvents: null,
        date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        menu: false,
        currentDate: null,
        dateNext: null,
        dateNextTwo: null,
        currentDateFormat: null,
        dateNextFormat: null,
        dateNextTwoFormat: null,
        nowDate: new Date().toISOString().slice(0, 10),
        segments: [],
        staffs: null,
        spaces: null,
        selectedSlot: {},
        openingHours: 9,
        closingHours: 18,
        spaces_list: null,
        staffs_list: null,
        nb_user: 1,
        time_slots: null,
        selectPracti: null,
        selectSpace: null,
        selectID: null,
        selectDate: null,
        isLoading: false,
        isLoadingOther: false,
        otherPrestations: {},
        otherSelect: 0,
        allPrestations: [],
        prestations: [],
        // prestationsBasket: null,
        booked: [],
        prestationSelected: true,
        showCalendar: false,
        showDisponibilities: false,
        selectedTimeSlot: null,
        numberToWord: [
            'Première',
            'Deuxième',
            'Troisième',
            'Quatrième',
            'Cinquième',
            'Sixième',
            'Septième',
            'Huitième',
            'Neuvième',
        ],
        practiDispo: null,
        practiShow: false,
        currentPracti: null,
        nbreStaff: 0,
        establishment: {},
        selectedStaff: null,
        trouve: false,
        showContiner: false,
        clicked: false,
    }),
    computed: {
        ldsSpan() {
            return {
                'font-family': 'Serif',
                color: '#000',
            }
        },
        ldsRing() {
            return {
                border: '3px solid #000',
                'border-color': '#000 transparent transparent transparent',
            }
        },
    },
    mounted() {
        ;(this.currentDateFormat = dayToFrFormat(addDays(this.date, 0))),
            (this.dateNextFormat = dayToFrFormat(addDays(this.date, 1))),
            (this.dateNextTwoFormat = dayToFrFormat(addDays(this.date, 2))),
            (this.arrayEvents = [...Array(6)].map(() => {
                const day = Math.floor(Math.random() * 30)
                const d = new Date()
                d.setDate(day)
                return d.toISOString().substr(0, 10)
            }))
        this.currentDate = addDays(this.date, 0)
        this.dateNext = addDays(this.date, 1)
        this.dateNextTwo = addDays(this.date, 2)
        this.checking()
        this.getAvaillableBook()
        this.getEstablishments()
        this.getCartPrestation()
        moment.locale('fr')
        this.nb_user = 1
        if (this.prestation.type >= 2) {
            this.nb_user = this.prestation.type
        }
        this.establishment = this.establishments
        this.getSpacesEsta(this.establishment.id)
        this.getStaffsEsta(this.establishment.id)
        this.first_name = this.user.first_name
        this.last_name = this.user.last_name
        if (!['serie', 'treatment'].includes(this.type)) {
            //this.getCartPrestation()
        } else {
            this.prestationSelected = true
        }
        for (let index = 0; index < this.nb_user; index++) {
            if (index == 0) {
                this.customers[index] = { first_name: this.first_name, last_name: this.last_name }
            } else {
                this.customers[index] = { first_name: '', last_name: '' }
            }
        }
    },

    methods: {
        displayDate(date) {
            if (moment(date).calendar().includes('/')) return moment(date).format('dddd Do MMMM YYYY à HH:mm')
            return moment(date).calendar()
        },

        setPracti(e) {
            this.showContiner = true
            if (this.currentPracti == e) this.currentPracti = null
            else this.currentPracti = e
        },
        async selectMultipleSlot(item, date, day, practi) {
            this.showContiner = false
            // item[0]["practi"] = practi
            // item['preference_practi'] = practi
            this.selectedSlot = {
                prestation: item,
                start_first_time: parseInt(moment(date).format('X')),
                end_first_time: parseInt(moment(date).format('X')) + parseInt(this.prestation.duration * 60),
                day: day,
                pref_prati: practi,
            }
            this.selectDate = item
            // console.log(item)
            item.forEach((element) => this.booked.push(element.rowId))
            //this.time_slots = []
            try {
                await axios.post(`/soin/reservation/confirmation`, {
                    all: JSON.stringify(this.selectedSlot),
                    nbUser: this.nb_user,
                    customers: this.customers,
                    preference_practi: practi,
                })

                this.allPrestations.push(this.selectedSlot)
                this.practiShow = false

                $('form').submit()
            } catch (error) {
                this.$toast.error(error.response.data.message)
                this.allPrestations.push(this.selectedSlot)
                this.practiShow = false
                $('form').submit()
            }
        },

        async selectMultipleSlotPackage(item, date, day) {
            this.selectedSlot = {
                prestation: item,
                start_first_time: parseInt(moment(date).format('X')),
                end_first_time: parseInt(moment(date).format('X')) + parseInt(this.prestation.duration),
                day: day,
            }
            this.selectDate = item
        },

        async displayAllPracti(ts) {
            //console.log('aaaaaaa')
            this.practiShow = false
            this.practiDispo = ts[0]['practi']
            this.selectedTimeSlot = ts
            this.practiShow = true
            let tab = []

            var exists = false
            var exist2 = false
            /*if(ts[0]['prestations_package'])
            var exists = ts.filter(field =>
               field['prestations_package'].filter(field2=>
                field2.prestation.staff_nbr!==-1
              )
            );
            console.log(JSON.stringify(exists));
            if(ts[0]['prestations'])
             exist2 = ts.filter(field =>
               field['prestation'].filter(field2 =>
               field2.staff_nbr!=-1)
              );
            */

            if (ts[0]['prestation'].staff_nbr == -1 || ts[0]['prestations_package'][0].prestation.staff_nbr == -1) {
                this.trouve = false
                this.clicked = true
                this.setPracti(null)
            } else {
                this.clicked = false
                if (this.spsp == -1) {
                    this.trouve = true
                } else {
                    this.trouve = true
                    this.setPracti(ts[0]['practi'][0])
                }
            }

            if (!this.trouve) {
                this.practiDispo = []
            }
        },

        async loadTimeslot() {
            this.isLoading = true
            try {
                if (this.type !== 'package' && this.type !== 'serie' && this.type !== 'treatment') {
                    let response = await axios
                        .post(`/reservation/getTimeSlot/2`, {
                            establishment: this.establishment,
                            staffs: this.staff,
                            spaces: this.spaces_list,
                            nb_user: this.nb_user,
                            prestations: this.prestations,
                            numberUser: this.nb_user,
                            type: this.prestation.type,
                            id_esta: this.establishment.id,
                            date: moment(this.date).format('x'),
                            selectedPrestations: this.sprs,
                        })
                        .then((response) => {
                            this.isLoading = false
                            this.time_slots = response.data
                        })
                        .catch((e) => {
                            this.isLoading = false
                        })
                } else {
                    let response = await axios
                        .post(`/forfait/getTimeSlot`, {
                            establishment: this.establishment,
                            staffs: this.staff,
                            spaces: this.spaces_list,
                            nb_user: this.nb_user,
                            prestations: [this.prestation],
                            numberUser: this.nb_user,
                            type: this.prestation.type,
                            id_esta: this.establishment.id,
                            date: moment(this.date).format('x'),
                        })
                        .then((response) => {
                            this.isLoading = false
                            this.time_slots = response.data
                        })
                        .catch((e) => {
                            this.isLoading = false
                        })
                }
            } catch (e) {
                this.isLoading = false
            }
        },
        async getCartPrestation() {
            axios.get('/getCartPrestations').then((res) => {
                this.prestations = []
                this.prestations = res.data
            })
        },
        timestampToDate(date) {
            return moment.unix(date)
        },
        async getAvaillableBook() {
            axios.get(`/getAvailable/${this.date}`).then((response) => {
                this.availableSlots = response.data
            })
        },
        async changeDate(event) {
            this.getAvaillableBook()
            this.currentDateFormat = dayToFrFormat(addDays(event, 0))
            this.dateNextFormat = dayToFrFormat(addDays(event, 1))
            this.dateNextTwoFormat = dayToFrFormat(addDays(event, 2))

            this.checking()
            this.getSpacesEsta(this.establishment.id)
            this.getStaffsEsta(this.establishment.id)
            this.loadTimeslot()
            this.showDisponibilities = true
            this.practiShow = false
        },
        checking() {
            // this.checkStaffs()
            // this.checkSpaces()
            // this.checkSlots()
            //   this.generateSlots()
        },

        async getSpacesEsta(esta) {
            let response = await axios
                .post(`/soin/getSpaces/${this.establishment.id}`, {
                    prestation_id: this.prestation.id,
                })
                .then((response) => {
                    this.spaces_list = response.data
                })
            return response
        },
        async getStaffsEsta(esta) {
            let response = await axios
                .post(`/soin/getStaffs/${this.establishment.id}`, {
                    prestation: this.prestation,
                })
                .then((response) => {
                    this.practiDispo = response.data
                    // this.currentPracti = response.data[0].id
                })
            return response
        },
        async getEstablishments() {
            await axios.post('/etablissements').then((response) => {
                this.establishmentsOptions = response
            })
        },
    },
}
</script>
<style scoped>
.tooltip {
    opacity: 1 !important;
    position: relative;
    display: inline-block;
    /* If you want dots under the hoverable text */
}

.v-date-picker-title {
    color: #000;
}

/* Tooltip text */
.tooltip .tooltiptext {
    visibility: hidden;
    background-color: #f1f1f1;
    color: #fff;
    text-align: center;
    padding: 5px 0;
    border-radius: 6px;
    top: -5px;
    left: 105%;
    width: 100%;
    /* -webkit-box-shadow: 7px 6px 19px 0px #000000;
box-shadow: 7px 6px 19px 0px #000000; */

    /* Position the tooltip text - see examples below! */
    position: absolute;
    z-index: 1;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
    visibility: visible;
}

div:deep(.v-application--wrap) {
    min-height: initial;
}

.component-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
}

.page-resa {
    padding-bottom: 10rem;
    width: 100%;
    gap: 20px;
    display: flex;
}

.sub-title-resa {
    font-size: 1.5rem;
    font-weight: 700;
}

.description-resa {
    margin-top: 2rem;
    margin-bottom: 2rem;
}

.description-resa li {
    color: gray;
    font-size: 12px;
    list-style-position: inside;
}

.resa-col-1 {
    flex: 3;
}

.resa-col-2-3 {
    display: flex;
    flex: 2;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}

@media (min-width: 2000px) {
    .resa-col-2-3 {
        flex-direction: row;
    }
}

.resa-col-2,
.resa-col-3 {
    max-width: 350px;
}

@media (max-width: 1279px) {
    .page-resa {
        flex-direction: column;
    }

    .resa-col-1,
    .resa-col-2,
    .resa-col-3 {
        width: 100%;
    }

    .resa-col-2,
    .resa-col-3 {
        max-width: fit-content;
        min-width: 100%;
    }
}

.title-resa {
    font-family: 'Playfair Display';
    color: black;
}

.calendar-container {
    width: 35%;
}

.titleSlot {
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: 1rem;
}

.slot-container {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
}

.slot-time {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-right: 1rem;
}

.card-slot {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid black;
    width: 12rem;
    padding: 1rem 0;
    margin: 1rem 0;
    transition: all 0.2s ease-in-out;
}

.card-slot:hover {
    background-color: black;
    color: #cca000;
}

.card-slot.active {
    background-color: black;
    color: #cca000;
}

.line-separator {
    border-left: 1px solid rgba(128, 128, 128, 0.772);
    height: auto;
    width: 1rem;
}

/*  */

.lds-ring {
    display: inline-block;
    position: relative;
    width: 40px;
    height: 40px;
}

.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    margin: 4px;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}

.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}

@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>
